import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '@app/services/message.service';
import { take } from 'rxjs';
import { AppToastComponent } from '../../../components/app-toast/app-toast.component';
import { QuickbooksStore } from '../quickbooks.store';

@Component({
  selector: 'app-qb-redirect',
  templateUrl: './qb-redirect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppToastComponent],
})
export class QbRedirectComponent implements OnInit {
  readonly store = inject(QuickbooksStore);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);

  ngOnInit(): void {
    this.store
      .completeConnection(this.activatedRoute.snapshot.queryParams)
      .pipe(take(1))
      .subscribe({
        next: async () => {
          await this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: null,
          });

          await this.router.navigate([`/invoices`], { queryParams: null });
        },
        error: async (e) => {
          this.messageService.add({
            severity: 'error',
            message: e?.error?.message || 'Connection error for the Company',
          });
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: null,
          });
          await this.router.navigate([`/quickbooks`], { queryParams: null });
        },
      });
  }
}
